import { render, staticRenderFns } from "./PdfLayoutCharts.vue?vue&type=template&id=44570e37&"
import script from "./PdfLayoutCharts.vue?vue&type=script&lang=js&"
export * from "./PdfLayoutCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports